window.$ = window.jQuery = require('jquery');
require('../vendor/js/bootstrap');
require('../vendor/js/jquery.sliderPro');
window.fancybox = require('@fancyapps/fancybox/dist/jquery.fancybox');
require('../vendor/js/owl.carousel');
require('../vendor/js/jquery.barrating.min');
require('../vendor/js/isotope.pkgd.min');
require('../vendor/js/scrollspy');
require('../vendor/js/moment');
require('../vendor/js/bootstrap-datetimepicker.min');
require('../vendor/js/jquery.form');
require('../vendor/js/jquery.form-validator');
require('../vendor/js/jquery.selectBox');
require('../vendor/js/jquery.matchHeight');
require('../vendor/js/imagesloaded.pkgd.min');
require('../vendor/js/masonry.pkgd.min');

// vegas form sender
require('../vendor/form-sender/js/jquery.vegasFormSender');
require('../vendor/form-sender/js/init');

require('./theme');
require('./functions');